import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * DELETE `/mom/work-order/{workOrderId}/amendment/{amendmentId}`。僅 DRAFT。
 *
 * @param {string} workOrderId
 * @param {string} amendmentId
 */
export async function deleteWorkOrderAmendment(workOrderId, amendmentId) {
  const { data: raw } = await request.delete(
    `/mom/work-order/${workOrderId}/amendment/${amendmentId}`,
  );
  return parseVer4DetailResponse(raw);
}
